import styled from 'styled-components';

export const AvatarStyled = styled.div`
  .avatar {
    width: ${({ size }) => size}px;
    height: ${({ size }) => size}px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    /* โทนอ่อน ไม่แย่งความเด่นจากชื่อ: พื้นฟ้าอ่อน ไอคอนน้ำเงิน ขอบบาง */
    background: ${({ theme }) => theme.COLORS.BLUE_1};
    color: ${({ theme }) => theme.COLORS.BLUE_4};
    border: 1px solid ${({ theme }) => theme.COLORS.GRAY_4};
    .avatar_img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .avatar_icon {
      display: block;
    }
  }

  .theme_standard {
  }
`;
